import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Table } from "antd";
import config from "../../../config";
import authHeader from "../../Authentication/authHeader";

export default function SupplierBalanceSummary({tabChange}) {
  const [supplierLedgers, setSupplierLedgers] = useState([]);
  const [salesLoading, setSalesLoading] = useState(false);

  const fetchData = async () => {
    try {
      setSalesLoading(true);
      const response = await axios.get(
        `${config.baseUrl}/inventory/party_ledger_consolidated_list/`,
        {
          headers: authHeader(),
        }
      );
      const resData = Array.isArray(response?.data) ? response?.data : [];
      setSupplierLedgers(resData);
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setSalesLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [tabChange]);

  const supplierLedgerColumns = [
    {
      title: "Supplier",
      dataIndex: "supplier_name",
    },

    {
      title: "Balance",
      render: (record) => {
        if (
          record?.last_balance === undefined ||
          record?.last_balance === null
        ) {
          return "0.00";
        }

        const balance = Number(record.last_balance.toFixed(2));
        const formatted = Math.abs(balance).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        return balance >= 0 ? `${formatted} Dr` : `${formatted} Cr`;
      },
    },
  ];
  const total = supplierLedgers.reduce(
    (acc, cur) => acc + Number(cur.last_balance || 0),
    0
  );

  return (
    <>
      <div className="farmerDashboard" style={{ width: "50%" }}>
        <div className="shadow-sm p-3">
          <Table
            columns={supplierLedgerColumns}
            dataSource={supplierLedgers}
            loading={salesLoading}
            rowKey={(record) => record?.pl_id}
            summary={() => (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={1}>
                  <strong>Total</strong>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1}>
                  <strong>
                    {total > 0
                      ? `${Number(total).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })} Dr`
                      : `${Number(Math.abs(total)).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })} Cr`}
                  </strong>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            )}
            size="small"
            pagination={false}
          />
        </div>
      </div>
    </>
  );
}
